import { type MotionValue, useMotionValue } from 'motion/react';
import React, { createContext, useMemo, useRef } from 'react';

import type { BasketBottomSheetRef } from '..';

export type BasketContextType = {
  indexValueListener: MotionValue<number>;
  basketSheetRef: React.RefObject<BasketBottomSheetRef>;
};

export const BasketContext = createContext<BasketContextType | null>(null);

type BasketContextProviderProps = {
  children: React.ReactNode;
};

export const BasketContextProvider: React.FC<BasketContextProviderProps> = ({ children }) => {
  const indexValueListener = useMotionValue(0);
  const basketSheetRef = useRef<BasketBottomSheetRef>(null);

  const contextValue = useMemo(() => ({ indexValueListener, basketSheetRef }), [indexValueListener]);

  return <BasketContext.Provider value={contextValue}>{children}</BasketContext.Provider>;
};

export const useBasketSheetContext = () => {
  const context = React.useContext(BasketContext);
  if (!context) {
    throw new Error('useBasketContext must be used within a BasketContextProvider');
  }
  return context;
};
